import React, { Fragment } from 'react';

import empty from '../../public/static/img/common/empty.png';
import Image from '../Image';

const EmptyMessage = ({ type }) => (
  <Fragment>
    <Image alt="Empty" src={empty} />
    <h3>Nothing came up</h3>
    <small>{`Not for long! Stay tuned for ${type} you'll love.`}</small>
  </Fragment>
);

export default EmptyMessage;
